import { reservationActionTypes } from './actionTypes';

const initialState = {
  captchaResponse: null,
  step: 0,
  slots: null,
  slotsFilters: {
    practitionerList: [],
    campusList: [],
    selectedValues: {
      campusIds: null,
      practitionerIds: null,
      startDate: null,
      endDate: null,
      dayTimePeriod: null,
      daysOfWeek: null,
      timeStamp: null
    }
  },
  activeSlot: null,
  questionSection: {
    questionList: [],
    behaviorList: [],
    questionResult: {}
  },
  preferData: null,
  prWithDigitalFlow: null
};

const isMobile = () => window.innerWidth <= 576;
const createCopy = obj => Object.assign({}, obj);
const createDeepCopy = obj => JSON.parse(JSON.stringify(obj));
const groupingPractitioners = list => {
  // list may be
  // 1) [Id1, Id2]
  // 2) [practitioner.id, practitioner.id]
  let tId = null;
  if (list && Array.isArray(list)) {
    const getAllIds = list.map(el => (el && el.id) || el);
    tId = getAllIds.join(',');
  }
  return {
    id: tId,
    localizations: [
      {
        lang: 'en',
        name: 'No preference'
      },
      {
        lang: 'nl',
        name: 'Geen voorkeur'
      }
    ]
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    //──── Common ────────────────────────────────────────────────────────────────────────────
    case reservationActionTypes.CLEAR_RESERVATION_STEP: {
      const tState = createCopy(initialState);
      if (state.preferData) {
        tState.preferData = state.preferData;
      }
      return tState;
    }
    case reservationActionTypes.CHANGE_STEP:
      return { ...state, step: action.payload };

    //──── Booking ───────────────────────────────────────────────────────────────────────────
    case reservationActionTypes.CREATE_BOOKING_SUCCESS: {
      if (state.activeSlot && action.payload && action.payload.id) {
        // add external id for connect with calendar in our app
        const tActiveSlot = createDeepCopy(state.activeSlot);
        tActiveSlot.externalId = action.payload.id;
        return { ...state, activeSlot: tActiveSlot };
      } else {
        return { ...state };
      }
    }
    case reservationActionTypes.CREATE_BOOKING_ERROR:
      return { ...state };

    //──── Campuses ──────────────────────────────────────────────────────────────────────────
    case reservationActionTypes.ADD_CAMPUSES: {
      const tSlotsFilters = createCopy(state.slotsFilters);
      tSlotsFilters.campusList = action.payload;
      return { ...state, slotsFilters: tSlotsFilters };
    }

    //──── Filters ───────────────────────────────────────────────────────────────────────
    case reservationActionTypes.SET_SLOTS_FILTERS: {
      const tSlotsFilters = createDeepCopy(state.slotsFilters);
      tSlotsFilters.selectedValues = createDeepCopy(action.payload);
      return { ...state, slotsFilters: tSlotsFilters };
    }
    case reservationActionTypes.UPDATE_SLOTS_FILTERS: {
      const keys = Object.keys(action.payload);
      const tSlotsFilters = createDeepCopy(state.slotsFilters);
      keys.forEach(_k => {
        if (
          JSON.stringify(action.payload[_k]) !== JSON.stringify(tSlotsFilters.selectedValues[_k])
        ) {
          tSlotsFilters.selectedValues[_k] = action.payload[_k];
        }
      });
      if (!isMobile()) {
        tSlotsFilters.selectedValues.timeStamp = new Date().toUTCString();
      }
      return { ...state, slotsFilters: tSlotsFilters };
    }
    case reservationActionTypes.CLEAR_SLOTS_FILTERS: {
      const tSlotsFilters = createDeepCopy(state.slotsFilters);
      tSlotsFilters.selectedValues = createDeepCopy(initialState.slotsFilters.selectedValues);
      return { ...state, slotsFilters: tSlotsFilters };
    }

    //──── Practitioners ─────────────────────────────────────────────────────────────────────
    case reservationActionTypes.SET_PRACTITIONERS: {
      const tSlotsFilters = createCopy(state.slotsFilters);
      tSlotsFilters.practitionerList = action.payload;
      return { ...state, slotsFilters: tSlotsFilters };
    }
    case reservationActionTypes.SET_GROUP_PRACTITIONERS: {
      const tSlotsFilters = createDeepCopy(state.slotsFilters);
      if (Array.isArray(tSlotsFilters.practitionerList.length) && tSlotsFilters.practitionerList.length) {
        if (!tSlotsFilters.practitionerList[0].lastName) {
          // have groping
          tSlotsFilters.practitionerList.slice(1);
        }
        if (Array.isArray(action.payload) && action.payload.length > 1) {
          tSlotsFilters.practitionerList.unshift(groupingPractitioners(action.payload));
          return { ...state, slotsFilters: tSlotsFilters };
        }
        return state;
      }
      return state;
    }
    case reservationActionTypes.CLEAR_GROUP_PRACTITIONERS: {
      const tSlotsFilters = createDeepCopy(state.slotsFilters);
      if (Array.isArray(tSlotsFilters.practitionerList.length) && tSlotsFilters.practitionerList.length && !tSlotsFilters.practitionerList[0].lastName) {
        // have groping
        tSlotsFilters.practitionerList = tSlotsFilters.practitionerList.slice(1);
        return { ...state, slotsFilters: tSlotsFilters };
      }
      return state;
    }
    case reservationActionTypes.SET_PR_WITH_DIGITAL_FLOW: {
      return { ...state, prWithDigitalFlow: action.payload };
    }

    //──── Prefer data ───────────────────────────────────────────────────────────────────────
    case reservationActionTypes.SET_PREFER_DATA: {
      return { ...state, preferData: action.payload };
    }
    case reservationActionTypes.CLEAR_PREFER_DATA: {
      return { ...state, preferData: null };
    }

    //──── Questions ─────────────────────────────────────────────────────────────────────────
    case reservationActionTypes.LOAD_QUESTION_LIST: {
      const tqs = createCopy(state.questionSection);
      tqs.questionList = action.payload;
      return { ...state, questionSection: tqs };
    }
    case reservationActionTypes.LOAD_QUESTION_BEHAVIOR_LIST: {
      const tqs = createCopy(state.questionSection);
      tqs.behaviorList = action.payload;
      return { ...state, questionSection: tqs };
    }
    case reservationActionTypes.SET_QUESTIONS_RESULT: {
      const tqs = createCopy(state.questionSection);
      tqs.questionResult = action.payload;
      return { ...state, questionSection: tqs };
    }
    case reservationActionTypes.CLEAR_QUESTIONS_RESULT: {
      const tqs = createCopy(state.questionSection);
      tqs.questionResult = {};
      return { ...state, questionSection: tqs };
    }

    //──── Slot actions ──────────────────────────────────────────────────────────────────────
    case reservationActionTypes.ADD_MORE_SLOTS: {
      return { ...state, slots: [...state.slots, ...action.payload] };
    }
    case reservationActionTypes.ERROR_LOAD_SLOTS:
      return { ...state, slots: action.payload };
    case reservationActionTypes.SUCCESS_LOAD_SLOTS:
      return { ...state, slots: action.payload };
    case reservationActionTypes.RESET_SLOTS:
      return { ...state, slots: [], activeSlot: null };
    case reservationActionTypes.SELECT_SLOT: {
      if (state.activeSlot && action.payload && state.activeSlot.id === action.payload.id) {
        return { ...state, activeSlot: null };
      }
      return { ...state, activeSlot: action.payload };
    }

    //──── Captcah ───────────────────────────────────────────────────────────────────────────
    case reservationActionTypes.SET_CAPTCHA_TOKEN:
      return { ...state, captchaResponse: action.payload };
    case reservationActionTypes.CLEAN_CAPTCHA_TOKEN:
      return { ...state, captchaResponse: null };

    default:
      return state;
  }
};
